<template>
  <div class="row mb-3 wrapper_input string" :class="wrapperClass">
    <label v-if="label" class="col-sm-6 col-form-label string" v-html="label" />
    <div class="col-sm row mx-0 align-items-center">
      <div class="input-group col" :class="groupClass">
        <slot />
        <span v-if="append" class="input-group-text">{{ append }}</span>
      </div>
      <div v-if="$slots.hint" class="col-auto form-text p-0 text-end">
        <slot name="hint" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string
    append?: string
    wrapperClass?: string
    groupClass?: string
  }>(),
  { label: '', append: '', wrapperClass: '', groupClass: '' },
)
</script>
